/**
 * Validates the height the pinned Favorites section
 * @param value - The height value to validate
 * @returns The value when it is a positive number greater than or equal to 30px
 * (which is the minimum height), otherwise returns null
 */
export default function getValidFavoritesPaneHeight(
    value: number | undefined | null
): number | null {
    if (typeof value === 'number') {
        return value >= 30 ? value : 30;
    }
    return null;
}
